module.exports = __webpack_public_path__ + "img/BLANCO_Capacitacion.84f5a99b.png";